export default __webpack_public_path__ + "static/media/BetLovelace.c5047cd0.png";